/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';

import MessageLimitModel from 'cio/models/message-limit';
import CampaignModel from 'cio/models/campaign';
import NewsletterModel from 'cio/models/newsletter';

interface MessagingLimitCountListArgs {
  messageLimit: MessageLimitModel;
}

export default class MessagingLimitCountList extends Component<MessagingLimitCountListArgs> {
  @computed('campaignsEnabledCounts.[]', 'broadcastsEnabledCounts.[]')
  get allEnabledCounts() {
    return [
      { label: 'Campaigns', count: this.campaignsEnabledCounts.length, items: this.campaignsEnabledCounts },
      { label: 'Broadcasts', count: this.broadcastsEnabledCounts.length, items: this.broadcastsEnabledCounts },
    ];
  }

  @computed('args.messageLimit.campaignsEnabled.content.@each.{id,name,messagingActions}')
  get campaignsEnabledCounts() {
    let campaignsEnabled = this.args.messageLimit.campaignsEnabled.content as CampaignModel[] | null;
    if (campaignsEnabled == null) {
      return [];
    }

    return campaignsEnabled.slice().map((c) => {
      let messagesCountAll = 0;
      try {
        messagesCountAll = c.messagingActions.length;
      } catch (e) {}

      return {
        id: c.id,
        name: c.name,
        type: 'campaign',
        messagesCountEnabled: Object.entries(this.args.messageLimit.campaignsEnabledMessageCounts).find(
          ([campaignID]) => String(campaignID) === c.id,
        )![1],
        messagesCountAll,
      };
    });
  }

  @computed(
    'args.messageLimit.newslettersEnabled.content.@each.{id,name}',
    'args.messageLimit.apiTbsEnabled.content.@each.{id,name,messagingActions}',
  )
  get broadcastsEnabledCounts() {
    let newslettersEnabled = this.args.messageLimit.newslettersEnabled.content as NewsletterModel[] | null;
    let apiTbsEnabled = this.args.messageLimit.apiTbsEnabled.content as CampaignModel[] | null;

    if (newslettersEnabled == null && apiTbsEnabled == null) {
      return [];
    }

    return [
      ...(newslettersEnabled ?? []).slice().map((c) => ({
        id: c.id,
        name: c.name,
        type: 'newsletter',
        messagesCountEnabled: Object.entries(this.args.messageLimit.newslettersEnabledMessageCounts).find(
          ([bID]) => String(bID) === c.id,
        )![1],
      })),
      ...(apiTbsEnabled ?? []).slice().map((c) => {
        let messagesCountAll = 0;
        try {
          messagesCountAll = c.messagingActions.length;
        } catch (e) {}

        return {
          id: c.id,
          name: c.name,
          type: 'apitb',
          messagesCountEnabled: Object.entries(this.args.messageLimit.apiTbsEnabledMessageCounts).find(
            ([bID]) => String(bID) === c.id,
          )![1],
          messagesCountAll,
        };
      }),
    ];
  }
}
